var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shadow-sm",attrs:{"id":"container"}},[_c('h1',[(this.icon != null)?_c('img',{attrs:{"src":this.icon}}):_vm._e(),_vm._v(_vm._s(_vm.title))]),_c('div',{attrs:{"id":"content"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }